module.exports = __webpack_public_path__ + "static/img/step2.763f25e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/step2.png
// module id = w0Bd
// module chunks = 1